/**
 * 该组件除了 Menu，也被 Breadcrumb 使用过
 * */
import tTitle from "../mixins/translate-title";
export default {
  name: 'iMenuHeadTitle',
  mixins: [tTitle],
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  }
};